import keycloakApi from './keycloak-auth';

export interface ReportListItem {
  id: string;
  file_name: string;
  description: string | null;
  file_url: string;
  file_size_bytes: string | null;
  status_type_id: number;
  processing_metadata: {
    runtime_stats?: {
      processing_duration_ms?: number;
      rows_processed?: number;
    };
    processing_notes?: string;
  } | null;
  created_by_name: string | null;
  created_at: string;
}

export interface PaginatedReports {
  success: boolean;
  data: ReportListItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNext: boolean;
    hasPrev: boolean;
  };
}

export interface GenerateReportParams {
  fileIds?: string[];
  partyIds?: string[];
  dateFrom?: string;
  dateTo?: string;
}

export interface GenerateReportResult {
  fileId: string;
  fileName: string;
  summary: {
    totalRows: number;
    generationDurationMs: number;
  };
}

const apiCall = async <T>(endpoint: string, options: RequestInit = {}): Promise<T> => {
  return keycloakApi.authenticatedApiCall<T>(endpoint, options);
};

export const listReports = async (page = 1, limit = 20): Promise<PaginatedReports> => {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });
  return apiCall<PaginatedReports>(`/reports?${params.toString()}`);
};

export const generateReport = async (
  params: GenerateReportParams
): Promise<GenerateReportResult> => {
  return apiCall<GenerateReportResult>('/reports/generate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
};
